import SessionHelper from './SessionHelper'

export const logisticsManager = () =>
  ['GEM', 'ADM'].includes(SessionHelper.role)
export const logisticsHome = () =>
  SessionHelper.role === 'TRA'
    ? '/logistica/transportista'
    : '/logistica/mensajeria'
export const logisticsRoles = ['GEM', 'ADM', 'TRA', 'MENSAJERO', 'ENT']
